// Admin sub-pages. Add a new entry here (and its component in AdminLayout's PAGES) to get a menu item + sub-nav link.
export const ADMIN_ITEMS = [
  { id: "access", path: "/admin/access", label: "Manage access", desc: "Who can sign in to the dashboard" },
  { id: "research", path: "/admin/research-studies", label: "Research Studies", desc: "ResearchStudies table from the database" },
];

export const adminItemFor = path => ADMIN_ITEMS.find(i => path === i.path || path.startsWith(i.path + "/"));
